import { h } from 'preact';

// TODO: better to add the non breaking space in php
export default function PlotPropertyField({ label, value }) {
	return (
		<tr>
			<th>{label}</th>
			<td>{typeof value === 'string' ? value.replace(/(€)(\s)/g, '$1' + String.fromCharCode(160)) : value}</td>
		</tr>
	);
}
